/** Sizes shared by the art of Glider PRO's pieces (world/kinds/gliderpro) and their runtime objects (game/objects/enemies). */

/** The goldfish's bowl; the water line is `surface` px below its top. */
export const BOWL = { w: 46, h: 36, surface: 10 };

/** The paper shredder. */
export const SHREDDER = { w: 90, h: 24 };
